import { render, staticRenderFns } from "./SList.vue?vue&type=template&id=37ddb938&scoped=true&functional=true&"
var script = {}
import style0 from "./SList.vue?vue&type=style&index=0&id=37ddb938&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "37ddb938",
  null
  
)

export default component.exports